import React, { FC } from 'react';
import { Typography } from 'antd';
type TextProps = React.ComponentProps<typeof Typography.Text>;

export const Text: FC<TextProps> = (props) => {
  const { Text: AntdText } = Typography;
  return <AntdText style={props.style}>{props.children}</AntdText>;
};
